import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { DarkModeContext } from '../../../App';
import Loading from '../../Shared/Loading';

const Project = ({project}) => {
    const [darkMode, setDarkMode] = useContext(DarkModeContext);
    if (!project) {
        <Loading></Loading>
    }
    const { name, description, sortDes, live, client, server, img } = project;
    return (
        <div className={`lg:max-w-lg shadow-green-500 shadow-md rounded-md ${darkMode ? 'bg-gray-900 text-gray-400' : 'bg-white'} transform hover:scale-105 transition duration-500`}>
            <figure className="">
                <img src={img} alt={name} className=" w-[356px] m-4 mx-auto h-60 rounded-t-md overflow-hidden" />
            </figure>
            <div className=" text-left ml-4 m-4">
                <h2 className={`text-2xl my-1 ${darkMode ? 'text-secondary':'text-accent'}`}>{name}</h2>
                <p> {sortDes}</p>
                <p><small>{description.slice(0, 170)}</small></p>
                <div className='flex'>

                <button className='btn bg-secondary lg:btn-sm btn-xs  my-4'>    
                <a className='inline-block tracking-widest text-xs text-white  mx-auto ' target='_blank' href={live}>LIVE</a>
                </button>
                <button className='btn bg-secondary lg:btn-sm btn-xs my-4 lg:mx-2 mx-1'>    
                <a className='inline-block tracking-widest text-xs text-white  mx-auto ' target='_blank' href={client}>CLIENT</a>
                </button>
                <button className='btn bg-secondary lg:btn-sm btn-xs  my-4'>    
                <a className='inline-block tracking-widest text-xs text-white  mx-auto '  target='_blank'href={server}>SERVER</a>
                </button>
                <button className='btn bg-secondary lg:btn-sm btn-xs my-4 lg:mx-2 mx-1'>    
                <Link className='inline-block tracking-widest text-xs text-white  mx-auto '  to={`/${project?.id}`}>DETAILS</Link>
                </button>
                </div>
            </div>
        </div>
    );
};

export default Project;